document.addEventListener('DOMContentLoaded', () => {
  class RelatedProductToast extends ModalDialog {
    constructor() {
      super();

      this.container = this.querySelector("#related-product-modal-container");
      this.querySelector(".close-button")?.addEventListener("click", this.hide.bind(this, false))
    }

    connectedCallback() {
      this.unsubscribe = undefined;
      this.style.zIndex = '-1';

      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source != 'cart-items' && !window.sessionStorage.getItem("relatedPopupSeen")) {
          this.show();
          this.style.zIndex = '';
          this.container.focus();
          window.sessionStorage.setItem("relatedPopupSeen", true)
        }
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
  }

  if (!customElements.get('related-product-modal')) {
    customElements.define('related-product-modal', RelatedProductToast);
  }
}, {once: true})